"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createXsollaCatalogClient = createXsollaCatalogClient;
exports.createXsollaPayStationClient = createXsollaPayStationClient;
const node_buffer_1 = require("node:buffer");
const openapi_fetch_1 = __importDefault(require("openapi-fetch"));
const XSOLLA_CATALOG_BASE_URL = 'https://store.xsolla.com/api';
const XSOLLA_PAY_STATION_BASE_URL = 'https://api.xsolla.com/merchant/v2';
function createXsollaClientAuthMiddleware(config) {
    return {
        onRequest({ request }) {
            const basicAuth = node_buffer_1.Buffer.from(`${config.merchantId}:${config.apiKey}`).toString('base64');
            request.headers.set('Authorization', `Basic ${basicAuth}`);
            request.headers.set('Content-Type', 'application/json');
            return request;
        },
    };
}
function createXsollaCatalogClient({ merchantId, apiKey, }) {
    const client = (0, openapi_fetch_1.default)({
        baseUrl: XSOLLA_CATALOG_BASE_URL,
    });
    client.use(createXsollaClientAuthMiddleware({ merchantId, apiKey }));
    return client;
}
function createXsollaPayStationClient({ merchantId, apiKey, }) {
    const client = (0, openapi_fetch_1.default)({
        baseUrl: XSOLLA_PAY_STATION_BASE_URL,
    });
    client.use(createXsollaClientAuthMiddleware({ merchantId, apiKey }));
    return client;
}
